import {connect, compose} from '@gisatcz/ptr-state';

import Select from "../../state/Select";
import presentation from './presentation';
import {withComponentId} from '../../hoc';

const mapStateToProps = (state, ownProps) => {
    return {
        activeMapKey: Select.maps.getActiveMapKey(state)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    };
};

export default compose(
    withComponentId('eo4sdDrrInsarMyanmar20_MainMap_'),
    connect(mapStateToProps, mapDispatchToProps)
)(presentation);
